import { AxiosResponse } from 'axios';
import { axiosAuthInstance } from '../../instance.ts';
import { IApplication, IMakeAnOffer, IApplicationsCountResponse } from './types.ts';

const ApplicationsAPI = {
  getAllApplications: (
    params: Record<string, any>,
  ): Promise<AxiosResponse<{ total: number; data: IApplication[] }, void>> =>
    axiosAuthInstance.get('/application/agency/', { params }),

  getApplicationsCount: (
    contractId?: number,
  ): Promise<IApplicationsCountResponse> =>
    axiosAuthInstance.get('/application/agency/count', {
      params: contractId ? { contractId } : undefined,
    }),

  getApplicationDetails: (id: number): Promise<IApplication> =>
    axiosAuthInstance.get(`/application/${id}/recruiter`),

  makeAnOffer: (id: number, data: IMakeAnOffer): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.post(`/application/${id}/make-offer/`, data),

  acceptApplication: (id: number): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.put(`/application/${id}/accept/`),

  cancelApplication: (id: number): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.put(`/application/${id}/cancel/`),

  declineApplication: (id: number, reason?: string): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.put(`/application/${id}/decline/`, reason),

  completeContract: (id: number, reason: string): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.post(`/application/${id}/complete-contract`, reason),

  cancelContract: (id: number, reason: string): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.post(`/application/${id}/cancel-contract`, reason),

  declineOfferRequest: (id: number, reason: string): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.post(`/application/${id}/decline-offer-request`, reason),

  approveOfferRequest: (id: number): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.post(`/application/${id}/approve-offer-request`),

  withdrawOffer: (id: number): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.post(`/application/${id}/withdraw-offer`),

  matchRateRefresh: (id: number): Promise<AxiosResponse<{ matchRate: number }>> =>
    axiosAuthInstance.get(`/application/${id}/match-rate-recalculate`),
};

export default ApplicationsAPI;
